import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/components/AuthProvider";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        // CRITICAL: populate the AuthContext BEFORE we navigate, otherwise
        // ProtectedRoute still sees user=null and bounces back to /admin/login.
        await refresh();
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true });
      } catch (e) {
        navigate("/admin/login", { replace: true, state: { error: "Login fehlgeschlagen" } });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-paper">
      <div className="text-center">
        <div className="animate-pulse font-serif text-2xl text-brand-primary">Anmeldung wird abgeschlossen…</div>
      </div>
    </div>
  );
}
